<template>
    <div class="operator-list">
      <div class="operator-item automation-single-cta operator-item-v2" v-if="Object.keys(offer).length > 0">
        <div class="operator-main flex flex-wrap mx-4">
          <div class="flex justify-center">
            <div class="operator-column-logo-v2">
              <div class="logo-wrapper">
                <a
                    class="operator-item__image_link exit-page-link block" rel="nofollow" target="_blank"
                    :href="offer.exit_link | appendfragment(ct, ctalocation, listId || '_', '_', rankVersion || '_', listPosition, '_')"
                    :data-gtm="gtm.replace('LOCATION', 'logo')"
                    data-kt="oplistclk:a|ctalocation|operator|product|offer|brand_id|brand_product_id|offer_id|site_offer_id"
                    :data-ctalocation="ctaLocation"
                    :data-operator="offer.brand_name"
                    :data-product="offer.brand_product_name"
                    :data-offer="offer.offer_short_description | striptags"
                    :data-brand_id="offer.brand_id"
                    :data-brand_product_id="offer.brand_product_id"
                    :data-offer_id="offer.offer_id"
                    :data-site_offer_id="offer.site_offer_id"
                >
                  <img
                      class="img-fluid lazyload"
                      :data-src="offer.brand_product_image"
                      :alt="offer.brand_product_name"
                      :title="offer.brand_product_name"
                  >
                </a>
                <div class="more_info_button d-flex align-items-center" v-if="showAttributes && this.lang != 'FR-CA'" v-on:click="moreInfo($event)">
                  <span class="more_info_text more_info_text">More Details</span>
                  <span class="more_info_arrow_down more_info_arrow"></span>
                </div>
              </div>
            </div>
          </div>
          <div class="flex-grow max-w-full flex-1 px-0">
            <div class="flex flex-wrap  lg:flex-nowrap mx-0">
              <div class="operator-column-bonus-v2 lg:w-full">
                <div class="offer-description">
                  <a
                      class="automation-play-now-cta operator-item__cta_link exit-page-link" rel="nofollow" target="_blank"
                      :href="offer.exit_link | appendfragment(ct, ctalocation, listId || '_', '_', rankVersion || '_', listPosition, '_')"
                      :data-gtm="gtm.replace('LOCATION', 'cta')"
                      data-kt="oplistclk:a|ctalocation|operator|product|offer|brand_id|brand_product_id|offer_id|site_offer_id"
                      style="color: initial"
                      :data-ctalocation="ctaLocation"
                      :data-operator="offer.brand_name"
                      :data-product="offer.brand_product_name"
                      :data-offer="offer.offer_short_description | striptags"
                      :data-brand_id="offer.brand_id"
                      :data-brand_product_id="offer.brand_product_id"
                      :data-offer_id="offer.offer_id"
                      :data-site_offer_id="offer.site_offer_id"
                  >
                    <div>
                      <p class="operator-bonus">
                        <span v-html="offer.offer_short_description"></span>
                        <span v-if="offer.promo_code"><br>Promo Code:
                              <em v-html="offer.promo_code"></em></span>
                      </p>
                    </div>
                  </a>
                </div>
              </div>
  
              <div class="operator-playnow-column-v2 w-[320px] m-auto">
                <a
                    class="automation-play-now-cta operator-item__cta_link exit-page-link" rel="nofollow" target="_blank"
                    :href="offer.exit_link | appendfragment(ct, ctalocation, listId || '_', '_', rankVersion || '_', listPosition, '_')"
                    :data-gtm="gtm.replace('LOCATION', 'cta')"
                    data-kt="oplistclk:a|ctalocation|operator|product|offer|brand_id|brand_product_id|offer_id|site_offer_id"
                    :data-ctalocation="ctaLocation"
                    :data-operator="offer.brand_name"
                    :data-product="offer.brand_product_name"
                    :data-offer="offer.offer_short_description | striptags"
                    :data-brand_id="offer.brand_id"
                    :data-brand_product_id="offer.brand_product_id"
                    :data-offer_id="offer.offer_id"
                    :data-site_offer_id="offer.site_offer_id"
                >
                  <span class="button-blue-v2" v-if="ctaText">{{ ctaText }}</span>
                  <span class="button-blue-v2" v-else-if="offer.product_type == 'Betting'">{{ betNowText }}</span>
                  <span class="button-blue-v2" v-else>{{ playNowText }}</span>
                </a>
                <div class="flex justify-center mt-3">
                  <div v-for="payment in payments" class="payment-provider" >
                    <img class="img-fluid payment-provider-img lazyload"
                        :data-src="payment.logo"
                        :title="payment.name"
                        width="30" height="24"
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="operator-item-link read-terms-link-v2">
          <div
              class="terms-and-conditions"
              v-if="offer.offer_terms_conditions"
              v-html="offer.offer_terms_conditions"
          ></div>
          <div class="terms-and-conditions" v-else>
            <span v-if="this.ipCountry == 'CA'">
                19+. T&C Apply. Play Responsibly
            </span>
            <span v-else-if="this.lang == 'FR-CA'">
                    19+. T&C s'appliquent. Jouez de manière responsable
            </span>
            <span v-else>
                <span v-html="getAge()"></span>+, terms apply, 1800-GAMBLER
            </span>
          </div>
        </div>
  
        <div v-if="showAttributes && this.lang != 'FR-CA'" class="more-info-table container more_info_table_392_11" style="display: block;">
          <div class="more-info-attributes mb-3 flex flex-wrap" style="padding: 0;">
            <div class="attributes-list lg:w-2/5 px-4 w-full" v-if="this.usps">
              <div class="green-tick attribute-list-item" v-for="item in this.usps">{{item.value}}</div>
            </div>
            <div class="lg:w-3/5 px-4 w-full px-4">
              <div class="flex flex-wrap">
                <div class="attribute w-1/2 md:w-1/3 px-4 basis-2/4 md:basis-4/12">
                  <div class="attribute-name flex">
                    <div class="attribute-name-text">
                      Promo Code
                    </div>
                  </div>
                  <span class="promo-code">
                      <em v-if="offer.promo_code" v-html="offer.promo_code"></em>
                      <span v-else>not required</span>
                  </span>
                </div>
                <div class="attribute w-1/2 md:w-1/3 pr-4 pl-4 basis-2/4 md:basis-4/12" v-for="attr in attributes">
                  <div class="attribute-name flex" v-if="attr && attr.attribute && attr.attribute.value">
                    <div class="attribute-name-text">
                      {{attr.label}}
                    </div>
                  </div>
                  <div class="attribute-value" v-if="attr && attr.attribute">
                    {{attr.attribute.value}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
      export default {
      name: 'single-offer',
      props: {
          id: {
              type: Number,
          },
          offer: {
              type: Object,
              required: true,
          },
          offerAttributes: {
            type: Object,
            required: true,
          },
          reviewLink: {
              type: String,
              required: false,
          },
          listLocation: {
              type: String,
              required: false,
          },
          listPosition: {
              type: Number,
              required: false,
              default: 1,
          },
          listId: {
              type: String,
              required: false,
          },
          rankVersion: {
              type: String,
              required: false,
          },
          imgPlaceholder: {
              type: String,
              required: true,
          },
          ct: {
              type: String,
              default: 'cta'
          },
          ctaLocation: {
              type: String,
              required: true,
          },
          ctaText: {
              type: String,
              required: false,
          },
          gtm: {
              type: String,
              required: true,
          },
          state: {
              type: String,
              required: false,
          },
          stateData: {
            type: Array|Object,
            required: false,
          },
      },
      data: function () {
          return {
                ctalocation: this.ctaLocation.replaceAll(" ", "_"),
                lang: $('html').attr('lang') ? $('html').attr('lang').toUpperCase() : false,
                ipCountry:  document.documentElement.getAttribute('data-ipcountry') ?
                            document.documentElement.getAttribute('data-ipcountry').toUpperCase() : false,
                regionCode: document.documentElement.getAttribute('data-regioncode') ?
                            document.documentElement.getAttribute('data-regioncode') : false,
          }
      },
      methods: {
          getAge() {
              return this.regionCode === 'RI' ? '18' : '21';
          },
          moreInfo(event) {
            const isClosed = (event.target.closest(".operator-item").querySelector('.more-info-table').style.display === 'none');
            let operatorItem =  event.target.closest(".operator-item");
            if (isClosed) {
                operatorItem.querySelector('.more-info-table').style.display = 'block';
                operatorItem.querySelector('.more_info_arrow').classList.remove('more_info_arrow_up');
                operatorItem.querySelector('.more_info_arrow').classList.add('more_info_arrow_down');
            } else {
                operatorItem.querySelector('.more-info-table').style.display = 'none';
                operatorItem.querySelector('.more_info_arrow').classList.add('more_info_arrow_up');
                operatorItem.querySelector('.more_info_arrow').classList.remove('more_info_arrow_down');
            }
          }
      },
      computed: {
          betNowText() {
              return window.translations.oplist.cta_bet_now || 'BET NOW';
          },
          playNowText() {
              return window.translations.oplist.cta_play_now || 'PLAY NOW';
          },
          payments() {
            if (this.offer && this.offer.payments) {
              return this.offer.payments.filter(item => this.state === item.us_state.code);
            }
  
            return null;
          },
          stateObject() {
            return Object.values(this.stateData).find((item) => item.code === this.state);
          },
          attributes() {
            let data = [];
            data = this.offerAttributes.attributes.map((item) => {
              item.attribute = Object.values(item.attributes).find((attr) => attr.country_region_id === this.stateObject.id);
              //If no rating fallback to 91
              if (item.label === 'Our Rating' && !item.attribute) {
                item.attribute = {value: 91};
              }
              return item;
            });
            return data;
          },
          usps() {
            let data = [];
            data = this.offerAttributes.usps.filter((item) => item.country_region_id === this.stateObject.id);
            return data.slice(0, 3);
          },
          showAttributes() {
            return this.attributes.every((item) => {
              if (!item.attribute || !item.attribute.value) {
                return false
              }
  
              return true
            });
          }
      }
  };
  </script>
  